
import * as React from 'react';
import { injectInitialProps } from '../../../utilities/components/Props';
import { IUploaderProps } from '../../uploader/Uploader';
import { UploadAction, IUploadActionProps } from './UploadAction';
import { IFileSystemDialogProps, FileSystemDialog } from '../../fileSystemDialog/FileSystemDialog';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { PlatformDetection } from '@ms/utilities-browser/lib/PlatformDetection';
import { ActionBase } from '../../action/Action';

class NoUpload extends React.PureComponent<IUploadFileActionProps> {
    public render(): JSX.Element {
        return React.createElement(ActionBase, {});
    }
}

const platformDetection = new PlatformDetection();

const UploadFileDialog = injectInitialProps((): Pick<IFileSystemDialogProps, 'type'> => ({ type: 'file' }))(FileSystemDialog);

export type IUploadFileActionProps = IDecoratedProps<IUploadActionProps, Pick<IUploaderProps, 'fileSelector'>, {}>;

export const UploadFileAction: React.ComponentType<IUploadFileActionProps> = platformDetection.isHtml5FileUploadSupported ?
    injectInitialProps((): Pick<IUploaderProps, 'fileSelector'> =>
        ({ fileSelector: UploadFileDialog }))(UploadAction) :
    NoUpload;
